<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Documents</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Drivers
                            </li>
                            <li class="breadcrumb-item active">Documents
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Driver's Documents</h4>
                </div>

                <div class="card-body">
                    <table id="recent-user-documents"
                           class="table table-responsive">
                        <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Document Name</th>
                            <th style="width: 10px">Document</th>
                            <th>Status</th>
                            <th>Date Submitted</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(document, i) in documents" :key="document.id">
                            <td class="text-truncate">{{ i + 1 }}</td>
                            <td class="text-truncate"> {{ document.name }}</td>
                            <td class="text-truncate" style="width: 10px">
                                <a :href="document.url">
                                    <img :src="document.url" :alt="document.name" style="width: 40px; height: 40px; object-fit: cover; border-radius: 6px;">
                                </a>
                            </td>
                            <td class="text-truncate">
                                 <span class="badge badge-glow"
                                       :class="document.status === 'approved' ? 'badge-success'
                                       : (document.status === 'submitted'  ? 'badge-warning': 'badge-danger')">
                                {{ document.status }}
                            </span>
                            </td>
                            <td class="text-truncate">{{ formatDateTime(document.date_created) }}</td>
                            <td class="text-truncate">
                                <a v-if="document.status !== 'approved' " href="#"
                                   @click.prevent="approve(document.id, document.driverId)">
                                    <i class="feather icon-check"></i> approve
                                </a>
                                <span v-if="document.status !== 'rejected' && document.status !== 'approved'">|</span>
                                <a v-if="document.status !== 'rejected' " href="#" @click.prevent="reject(document.id, document.driverId)"
                                   class="text-danger">
                                    <i class="feather icon-edit"></i> reject
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Driver'},
    props: ['documents'],
    name: "DriverDocumentIndex",
    layout: Layout,

    data: () => ({
        isLoadingFilter: false,
        tableDataLoading: false,
    }),
    created() {
        //
    },
    methods: {
        approve(documentId, driverId) {
            this.$inertia.patch(route('admin.drivers.document.approve', [driverId, documentId]),
                {status: 1}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        // const agentIndex = this.agent.findIndex(a => agent.id === a.id);
                        // this.agent[agentIndex].status = this.agent[agentIndex].status === 1 ? 0 : 1;
                    }
                });
        },
        reject(documentId, driverId) {
            this.$inertia.post(route('admin.drivers.document.reject', [driverId, documentId]),
                {status: 1}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        // const agentIndex = this.agent.findIndex(a => agent.id === a.id);
                        // this.agent[agentIndex].status = this.agent[agentIndex].status === 1 ? 0 : 1;
                    }
                });
        },

        formatDateTime(value) {
            if (!value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
    }
}
</script>
